<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g id="icon">
      <rect
        x="2.5"
        y="4.5"
        width="16"
        height="12"
        rx="1"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.5,5.5l8,5.5l8,-5.5"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
